import cn from 'classnames'
import { base_colorAction, text_colorTextSuccess } from 'ext-ui/style/colors'
import React from 'react'
import { TodoItem, WriteTodosToolCall } from 'src/agent/types/streamingTypes'
import SvgCheck from 'src/components/Svgs/SvgCheck'
import SvgMore from 'src/components/Svgs/SvgMore'
import { useTranslate } from 'src/localization/Trns'

import styles from './TodoListRenderer.style'

interface TodoListRendererProps {
  toolCall: WriteTodosToolCall
}

/**
 * Renders a todo list with status indicators
 */
const TodoListRenderer: React.FC<TodoListRendererProps> = ({ toolCall }) => {
  const { todos } = toolCall.args
  const translate = useTranslate()

  const getStatusIcon = (status: TodoItem['status']) => {
    switch (status) {
      case 'completed':
        return (
          <div className={'progress-icon completed'}>
            <SvgCheck
              width={24}
              height={24}
              viewBox={'0 0 24 24'}
              fill={text_colorTextSuccess}
            />
          </div>
        )
      case 'in_progress':
        return (
          <div className={'progress-icon in_progress'}>
            <SvgMore
              width={16}
              height={16}
              viewBox={'0 0 24 24'}
              fill={base_colorAction}
            />
          </div>
        )
      case 'pending':
      default:
        return <div className={'progress-icon pending'} />
    }
  }

  return (
    <div css={styles} className="TodoListRenderer">
      <div className="title">{translate('Task Progress')}</div>
      <div className="todo-list">
        {todos.map((todo, idx) => (
          <div key={`${toolCall.id}-todo-${idx}`} className="todo-item">
            <div className="icon">{getStatusIcon(todo.status)}</div>
            <div className={cn('content', todo.status)}>{todo.content}</div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default TodoListRenderer
